export const ISSUERS = {
    ORC: 'orchestration',
    CNX: 'connectX',
    OPT: 'optima',
    KNN: 'kenan',
    BE: 'backend',
    BSS: 'dbss'
};

export const HTTP_HEADERS = {
    CONTENT_TYPE: 'Content-Type',
    TENANT_ID: 'tenantId',
    SERVER_ID: 'serverId',
    AUTHORIZATION: 'Authorization',
    SESSION_ID: 'Sessionid',
    ACCEPT: 'Accept',
    X_API_KEY: 'x-api-key',
    X_AUTH_TOKEN: 'x-auth-token',
    LOCALE: 'locale'
};